import React, { useEffect, useState } from "react";
import { t } from "../services/locale.service";
import PlotSerivce, { TPlotPayload } from "../services/plot.service";
import { useParams } from "react-router-dom";
import { TPlot } from "stencil-library";

const IrrigationHour = () => {
  const { plotId } = useParams();
  const isSprinklerhour = localStorage.getItem("isSprinklerHour");

  const [isSprinklerHour, setIsSprinklerHour] = useState<boolean>(isSprinklerhour==="true");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sprinklerIrigationHour, setSprinklerHour] = useState<
    number | string
  >();
  const [irrigationHour, setIrrigationHour] = useState<number | string | null>();
  const [irrigation, setIrrigation] = useState<{
    dripperdischarge: number | null;
    rootwidth: number | null;
    rootdepth: number | null;
    soilretention: number | null;
    dripperDistance: number | null;
  }>();

  const formatIrrigationHour = (time: number) => {
    const irrigationHour = Math.floor(time);
    let irrigationTime = time - irrigationHour;
    irrigationTime = Math.floor(irrigationTime * 60);

    return (
      irrigationHour + ` ${t("hours")}: ` + irrigationTime + ` ${t("minutes")}`
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const plotData = await PlotSerivce.getPlotData(plotId!);
        if (plotData) {
          setIsLoading(true);
          const irrigationValues: {
            dripperdischarge: number | null;
            rootwidth: number | null;
            rootdepth: number | null;
            soilretention: number | null;
            dripperDistance: number | null;
          } = {
            dripperdischarge: null,
            rootwidth: null,
            rootdepth: null,
            soilretention: null,
            dripperDistance: null,
          };

          const extendedPlotData = plotData as TPlot & {
            dripperDischarge?: number;
            rootWidth?: number;
            rootDepth?: number;
            soilRetention?: number;
            dripperDistance?: number;
            irrigationHours?: number;
          };

          if (extendedPlotData?.dripperDischarge)
            irrigationValues.dripperdischarge = extendedPlotData.dripperDischarge;

          if (extendedPlotData?.rootWidth)
            irrigationValues.rootwidth = extendedPlotData.rootWidth;

          if (extendedPlotData?.rootDepth)
            irrigationValues.rootdepth = extendedPlotData.rootDepth;

          if (extendedPlotData?.soilRetention)
            irrigationValues.soilretention = extendedPlotData.soilRetention;

          if (extendedPlotData?.dripperDistance)
            irrigationValues.dripperDistance = extendedPlotData.dripperDistance;

          if (extendedPlotData?.irrigationHours) {
            const time = formatIrrigationHour(extendedPlotData.irrigationHours);

            if (!isSprinklerHour) setIrrigationHour(time);
            else setSprinklerHour(time);
          }
          setIrrigation(irrigationValues);
          setIsLoading(false);
        }

      } catch (error) {
        console.error("Error fetching plot data:", error);
      }
    };

    fetchData();
  }, [plotId]);

  const handleIrrigationHour = async () => {
    setIsLoading(true);
    localStorage.setItem("isSprinklerHour", JSON.stringify(isSprinklerHour));
    const res = isSprinklerHour
      ? await PlotSerivce.getIrrigationHourBySprinkler({
        a: irrigation?.rootdepth as number,
        b: irrigation?.soilretention as number,
        c: irrigation?.dripperdischarge as number,
      })
      : await PlotSerivce.getIrrigationHour({
        a: irrigation?.rootwidth as number,
        b: irrigation?.rootdepth as number,
        c: irrigation?.soilretention as number,
        d: irrigation?.dripperDistance as number,
        e: irrigation?.dripperdischarge as number,
      });
    if (res?.result) {
      const requiredHours = formatIrrigationHour(res?.result);
      const payload: TPlotPayload = {
        rootDepth: irrigation?.rootdepth as number,
        soilRetention: irrigation?.soilretention as number,
        dripperDischarge: irrigation?.dripperdischarge as number,
        irrigationHours: res?.result,
      };
      if (!isSprinklerHour) {
        setIrrigationHour(requiredHours);
        payload.rootWidth = irrigation?.rootwidth as number;
        payload.dripperDistance = irrigation?.dripperDistance as number;
      } else {
        setSprinklerHour(requiredHours);
      }
      await PlotSerivce.patchPlot(payload, plotId!);
    }
    setIsLoading(false);
  };

  const handleChange = (key: string, value: string) => {
    setIrrigation((prevState) => ({
      ...(prevState as {
        dripperdischarge: number | null;
        rootwidth: number | null;
        rootdepth: number | null;
        soilretention: number | null;
        dripperDistance: number | null;
      }),
      [key]: Number(value),
    }));
  };

  return (
    <div>
      <p
        style={{
          fontWeight: "bold",
          fontFamily: "RobotoBold",
          padding: "0px 10px",
          fontSize: 18,
          alignSelf: "center",
          width: "86%",
        }}
      >
        {t("Irrigation")} {t("hours")}
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignSelf: "center",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <input
            type="checkbox"
            checked={!isSprinklerHour}
            onChange={() => setIsSprinklerHour(false)}
            style={{ marginLeft: 10 }}
          />
          <p style={{ marginLeft: 5 }}>{t("DripIrrigation")}</p>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <input
            type="checkbox"
            checked={isSprinklerHour}
            onChange={() => setIsSprinklerHour(true)}
            style={{ marginLeft: 10 }}
          />
          <p style={{ marginLeft: 5 }}>{t("Sprinkler")}</p>
        </div>
      </div>

      <div
        style={{
          width: "86%",
          alignSelf: "center",
          padding: 8,
        }}
      >
        {!isSprinklerHour && (
          <div style={styles.irrigationInputContainer}>
            <p style={styles.sm1Label}>{t("rootWidth")}:</p>
            <input
              type="number"
              value={irrigation?.rootwidth?.toString()}
              onChange={(e) => handleChange("rootwidth", e.target.value)}
              style={styles.irrigationInput}
            />
          </div>
        )}

        <div style={styles.irrigationInputContainer}>
          <p style={styles.sm1Label}>{t("rootDepth")}:</p>
          <input
            type="number"
            value={irrigation?.rootdepth?.toString()}
            onChange={(e) => handleChange("rootdepth", e.target.value)}
            style={styles.irrigationInput}
          />
        </div>

        <div style={styles.irrigationInputContainer}>
          <p style={styles.sm1Label}>
            {isSprinklerHour ? t("sprinklerDischarge") : t("dripperDischarge")}:
          </p>
          <input
            type="number"
            value={irrigation?.dripperdischarge?.toString()}
            onChange={(e) => handleChange("dripperdischarge", e.target.value)}
            style={styles.irrigationInput}
          />
        </div>

        <div style={styles.irrigationInputContainer}>
          <p style={styles.sm1Label}>{t("soilRetention")}:</p>
          <input
            type="number"
            value={irrigation?.soilretention?.toString()}
            onChange={(e) => handleChange("soilretention", e.target.value)}
            style={styles.irrigationInput}
          />
        </div>

        {!isSprinklerHour && (
          <div style={styles.irrigationInputContainer}>
            <p style={styles.sm1Label}>{t("dripperDistance")}:</p>
            <input
              type="number"
              value={irrigation?.dripperDistance?.toString()}
              onChange={(e) => handleChange("dripperDistance", e.target.value)}
              style={styles.irrigationInput}
            />
          </div>
        )}

        {!isLoading &&
          (isSprinklerHour
            ? sprinklerIrigationHour
            : irrigationHour) && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <p style={{ fontFamily: "RobotoBold", fontSize: 20 }}>
              {t("Irrigation")} {t("hours")}:
            </p>
            <p
              style={{
                fontFamily: "RobotoBold",
                fontSize: 17,
                alignSelf: "center",
              }}
            >
              {isSprinklerHour
                ? sprinklerIrigationHour
                : irrigationHour}
            </p>
          </div>
        )}

        <button
          style={styles.calculateButton}
          disabled={
            (isSprinklerHour
              ? !irrigation?.rootdepth ||
                !irrigation?.soilretention ||
                !irrigation?.dripperdischarge ||
                isLoading
              : !irrigation?.rootwidth ||
                !irrigation?.rootdepth ||
                !irrigation?.soilretention ||
                !irrigation?.dripperDistance ||
                !irrigation?.dripperdischarge) || isLoading
          }
          onClick={handleIrrigationHour}
        >
          <p style={styles.buttonText}>
            {!isLoading &&
            (isSprinklerHour
              ? sprinklerIrigationHour
              : irrigationHour)
              ? t("ReCalculateValue")
              : t("CalculateValue")}
          </p>
        </button>
      </div>
    </div>
  );
};

const styles = {
  irrigationInputContainer: {
    marginTop: 10,
    marginBottom: 10,
  },
  sm1Label: {
    fontSize: 16,
    fontFamily: "RobotoRegular",
    marginBottom: 5,
  },
  irrigationInput: {
    height: 40,
    width: "100%",
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 5,
    padding: "0 10px",
    fontSize: 16,
  },
  calculateButton: {
    backgroundColor: "#0c9611",
    borderRadius: 12,
    width: "100%",
    paddingVertical: 25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    border: "none",
    height: 35,
    margin: "0 auto",
  },
  buttonText: {
    fontSize: 20,
    color: "white",
    alignSelf: "center",
    margin: 0,
  },
};

export default IrrigationHour;
